import { AbstractControl } from "@angular/forms";

const patternPortuguese: RegExp = /^[pP][tT]([0-9]|\*){23}$/;
const patternForeign: RegExp = /^([A-Z]{2})([a-zA-Z0-9]){13,32}$/;
const checkPTIban: RegExp = /^[pP][tT]/;

export function IbanValidator(control: AbstractControl): null | object {
    if (!control.value) {
        return null;
    } else if (null !== control.value.match(/\s/g, "")) {
        // removing spaces from IBAN (to respect validation pattern)
        control.setValue(
            control.value.replace(/\s/g, ""),
            { onlySelf: true, emitEvent: false }
        );
        control.updateValueAndValidity();
    }

    if (patternPortuguese.test(control.value)) {
        return null;
    }

    if (!checkPTIban.test(control.value) && patternForeign.test(control.value)) {
        return null;
    }

    if (checkPTIban.test(control.value)) {
        return { pattern: true };
    }

    return { patternForeign: true };
}
